import { callApi } from './Api';
import { push } from 'react-router-redux'
import { actionCreator } from './helpers'

export const GET_CAMPAIGNS_TABLES = 'GET_CAMPAIGNS_TABLES';
export const GET_CAMPAIGNS_CSV_DATA = "GET_CAMPAIGNS_CSV_DATA";
export const GET_EMAIL_CAMPAIGN_LIST = "GET_EMAIL_CAMPAIGN_LIST";
export const GET_SOCIAL_CAMPAIGN_LIST = "GET_SOCIAL_CAMPAIGN_LIST";
export const GET_DISPLAY_CAMPAIGN_LIST = "GET_DISPLAY_CAMPAIGN_LIST";
export const GET_CAMPAIGN_GROUP_AGGREGATED = "GET_CAMPAIGN_GROUP_AGGREGATED";
export const GET_CAMPAIGN_AGGREGATED_BY_CHANNEL = "GET_CAMPAIGN_AGGREGATED_BY_CHANNEL";
export const GET_CAMPAIGN_DETAIL = "GET_CAMPAIGN_DETAIL";
export const GET_CAMPAIGN_EMAIL_AGGREGATED = "GET_CAMPAIGN_EMAIL_AGGREGATED";
export const GET_CAMPAIGN_EMAIL_STATS_AGGREGATED = "GET_CAMPAIGN_EMAIL_STATS_AGGREGATED";
export const GET_CAMPAIGN_SOCIAL_AGGREGATED = "GET_CAMPAIGN_SOCIAL_AGGREGATED";
export const GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED = "GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED";
export const GET_CAMPAIGN_TOP_LINK_STATS = "GET_CAMPAIGN_TOP_LINK_STATS";
export const GET_CAMPAIGN_TOP_LOCATION_STATS = "GET_CAMPAIGN_TOP_LCOATION_STATS";
export const GET_CAMPAIGN_DISPLAY_AGGREGATED = "GET_CAMPAIGN_DISPLAY_AGGREGATED";
export const GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED = "GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED";
export const SET_REPORT_DATE_RANGE = "SET_REPORT_DATE_RANGE";
export const SET_CHANNEL_CAMPAIGN_ID = "SET_CHANNEL_CAMPAIGN_ID";
export const SET_SEGMENT_ID = "SET_SEGMENT_ID";
export const SET_CAMPAIGN_FILTER_START_DATE = "SET_CAMPAIGN_FILTER_START_DATE";
export const SET_CAMPAIGN_FILTER_END_DATE = "SET_CAMPAIGN_FILTER_END_DATE";
export const SET_CAMPAIGN_FILTER_VALUE = "SET_CAMPAIGN_FILTER_VALUE";
export const SAVE_CAMPAIGN_GROUP = "SAVE_CAMPAIGN_GROUP";
export const CLEAR_CAMPAIGN_DETAIL = "CLEAR_CAMPAIGN_DETAIL";
export const CLEAR_CMAPAIGNS_CSV_DATA = "CLEAR_CMAPAIGNS_CSV_DATA";
export const CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE = "CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE";

export const clearCampaignDetail = actionCreator(CLEAR_CAMPAIGN_DETAIL);
export const clearCampaignCsvData = actionCreator(CLEAR_CMAPAIGNS_CSV_DATA);
export const clearSaveCampaignErrorMessage = actionCreator(CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE);
export const setReportDateRange = actionCreator(SET_REPORT_DATE_RANGE);
export const setChannelCampaignId = actionCreator(SET_CHANNEL_CAMPAIGN_ID);
export const setSegmentId = actionCreator(SET_SEGMENT_ID);
export const setCampaignFilterStartDate = actionCreator(SET_CAMPAIGN_FILTER_START_DATE);
export const setCampaignFilterEndDate = actionCreator(SET_CAMPAIGN_FILTER_END_DATE);
export const setCampaignFilterValue = actionCreator(SET_CAMPAIGN_FILTER_VALUE);

export const getTables = (obj) => (dispatch, getState) => {
  const url = 'campaigns/search';

  callApi(dispatch, getState, GET_CAMPAIGNS_TABLES, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}

export const getCampaignCSV = (obj) => (dispatch, getState) => {
  const url = 'campaigns/search';
  callApi(dispatch, getState, GET_CAMPAIGNS_CSV_DATA, url, {
    method: "POST",
    body: JSON.stringify(obj)
  })
}

export const getChannelCampaignList = (channel, startDate, endDate) => (dispatch, getState) => {
  const url = `campaigns/channels/${channel}?from=${startDate}&to=${endDate}`;
  let dataType;
  switch(channel) {
    case "social":
      dataType = GET_SOCIAL_CAMPAIGN_LIST;
      break;
    case "display":
      dataType = GET_DISPLAY_CAMPAIGN_LIST;
      break;
    case "email":
    default:
      dataType = GET_EMAIL_CAMPAIGN_LIST;
      break;
  }
  callApi(dispatch, getState, dataType, url);
}

export const getCampaignById = (id, redirect, clientId) => (dispatch, getState) => {
  const url = `campaigns/${id}`;
  if (redirect) {
    callApi(dispatch, getState, GET_CAMPAIGN_DETAIL, url, {method:"GET"}, {
      success:()=>{
        let search = '';
        if (clientId) {
          search = '?cid=' + clientId;
        }
        dispatch(push(`/campaigns/edit/${id}${search}`))
      }
    });
  } else {
    callApi(dispatch, getState, GET_CAMPAIGN_DETAIL, url);
  }

}

export const saveCampaignGroup = (data) => (dispatch, getState) => {
  callApi(dispatch, getState, SAVE_CAMPAIGN_GROUP, "campaigns", {
    method: 'POST',
    body: JSON.stringify(data)
  }, {success:()=>{dispatch(push("/campaigns"))}})
}

export const getCampaignGroupAggregated = (campaignId, dateRange) => (dispatch, getState) => {
  //callApi(dispatch, getState, GET_CAMPAIGN_GROUP_AGGREGATED, `campaigns/aggregated/${campaignId}/${dateRange}`);
  callApi(dispatch, getState, GET_CAMPAIGN_GROUP_AGGREGATED, `campaigns/${campaignId}/message-engagement-timeseries/${dateRange}`);
}

export const getCampaignChannelAggregated = (campaignId, dateRange) => (dispatch, getState) => {
  callApi(dispatch, getState, GET_CAMPAIGN_AGGREGATED_BY_CHANNEL, `campaigns/${campaignId}/message-engagement-by-channel/${dateRange}`);
}

export const getEmailChannelAggregated = (groupCampaignId, deploymentId, dateRange, channelCampaignId) => (dispatch, getState) => {
  let url = deploymentId === "aggregated" ? `campaigns/${groupCampaignId}/email/activities-timeseries/${dateRange}` :
  `campaigns/${groupCampaignId}/email/activities-timeseries/${dateRange}?deploymentId=${deploymentId}`
  if (channelCampaignId && channelCampaignId !== 'aggregated') {
    url += `&channelCampaignId=${channelCampaignId}`
  }
  callApi(dispatch, getState, GET_CAMPAIGN_EMAIL_AGGREGATED, url);
    //`campaigns/report/email/${groupdCampaignId}/${campaignId}/${dateRange}`);
}

export const getSocialChannelAggregated = (groupCampaignId, deploymentId, dateRange, channelCampaignId) => (dispatch, getState) => {
  let url = deploymentId === "aggregated" ? `campaigns/${groupCampaignId}/social/activities-timeseries/${dateRange}` :
  `campaigns/${groupCampaignId}/social/activities-timeseries/${dateRange}?deploymentId=${deploymentId}`
  if (channelCampaignId && channelCampaignId !== 'aggregated') {
    url += `&channelCampaignId=${channelCampaignId}`
  }
  callApi(dispatch, getState, GET_CAMPAIGN_SOCIAL_AGGREGATED, url);
}

export const getDisplayChannelAggregated = (groupCampaignId, deploymentId, dateRange, channelCampaignId) => (dispatch, getState) => {
  let url = deploymentId === "aggregated" ? `campaigns/${groupCampaignId}/display/activities-timeseries/${dateRange}` :
  `campaigns/${groupCampaignId}/display/activities-timeseries/${dateRange}?deploymentId=${deploymentId}`
  if (channelCampaignId && channelCampaignId !== 'aggregated') {
    url += `&channelCampaignId=${channelCampaignId}`
  }
  callApi(dispatch, getState, GET_CAMPAIGN_DISPLAY_AGGREGATED, url);
}

export const getEmailChannelStatsAggregated = (groupCampaignId, deploymentId, dateRange, channelCampaignId) => (dispatch, getState) => {
  let url = deploymentId === "aggregated" ? `campaigns/${groupCampaignId}/email/campaign-stats/${dateRange}` : 
  `campaigns/${groupCampaignId}/email/campaign-stats/${dateRange}?deploymentId=${deploymentId}`
  if (channelCampaignId && channelCampaignId !== 'aggregated') {
    url += `&channelCampaignId=${channelCampaignId}`
  }

  callApi(dispatch, getState, GET_CAMPAIGN_EMAIL_STATS_AGGREGATED, url);
}

export const getSocialChannelStatsAggregated = (groupCampaignId, deploymentId, dateRange, channelCampaignId) => (dispatch, getState) => {
  let url = deploymentId === "aggregated" ? `campaigns/${groupCampaignId}/social/campaign-stats/${dateRange}` : 
  `campaigns/${groupCampaignId}/social/campaign-stats/${dateRange}?deploymentId=${deploymentId}`
  if (channelCampaignId && channelCampaignId !== 'aggregated') {
    url += `&channelCampaignId=${channelCampaignId}`
  }

  callApi(dispatch, getState, GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED, url);
}

export const getDisplayChannelStatsAggregated = (groupCampaignId, deploymentId, dateRange, channelCampaignId) => (dispatch, getState) => {
  let url = deploymentId === "aggregated" ? `campaigns/${groupCampaignId}/display/campaign-stats/${dateRange}` : 
  `campaigns/${groupCampaignId}/display/campaign-stats/${dateRange}?deploymentId=${deploymentId}`
  if (channelCampaignId && channelCampaignId !== 'aggregated') {
    url += `&channelCampaignId=${channelCampaignId}`
  }

  callApi(dispatch, getState, GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED, url);
}

export const getCampaignTopLinkStats = (groupCampaignId, channelCampaignId, dateRange, rowCount, type) => (dispatch, getState) => {
  const url = rowCount ?
  `campaigns/${groupCampaignId}/channel-campaigns/${channelCampaignId}/top-links-clicked/${dateRange}?limit=${rowCount}` : 
  `campaigns/${groupCampaignId}/channel-campaigns/${channelCampaignId}/top-links-clicked/${dateRange}`
  callApi(dispatch, getState, GET_CAMPAIGN_TOP_LINK_STATS, url);
}

export const getCampaignTopLocationClickStats = (groupCampaignId, channelCampaignId, dateRange, rowCount, type) => (dispatch, getState) => {
  callApi(dispatch, getState, GET_CAMPAIGN_TOP_LOCATION_STATS,
    `campaigns/${groupCampaignId}/channel-campaigns/${channelCampaignId}/top-locations/${dateRange}?limit=${rowCount ? rowCount : ""}`)
}



// WEBPACK FOOTER //
// ./src/actions/Campaign.js